module.exports = __webpack_public_path__ + "static/media/objects2_22.57086e7b.svg";